import { zipObj } from 'ramda';

export const journeyStatusEnums = ['DRAFT', 'PAUSED'];

//this creates an object where key and value are the same string as in the above array
const enums = zipObj(journeyStatusEnums, journeyStatusEnums);

export default enums;



// WEBPACK FOOTER //
// ./src/Enums/journeyStatus.js